import * as React from "react";

const SvgStillestoppen = React.forwardRef((props, ref) => {
  return (
    <svg
      id="stillestoppen_svg__Ebene_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x={0}
      y={0}
      viewBox="0 0 1920 2350"
      xmlSpace="preserve"
      {...props}
      ref={ref}
    >
      <style>{".stillestoppen_svg__st0{fill:#fff}"}</style>
      <g id="stillestoppen_svg__dot-top-right" opacity={0}>
        <path
          className="stillestoppen_svg__st0"
          d="M1733.4 638.3c17.2 0 31.2-14 31.2-31.2s-14-31.2-31.2-31.2-31.2 14-31.2 31.2 13.9 31.2 31.2 31.2"
          id="stillestoppen_svg__Punkte"
        />
      </g>
      <g id="stillestoppen_svg__dot-bottom-right" opacity={0}>
        <path
          className="stillestoppen_svg__st0"
          d="M1847.2 1701.5c17.2 0 31.2-14 31.2-31.2s-14-31.2-31.2-31.2-31.2 14-31.2 31.2 14 31.2 31.2 31.2"
          id="stillestoppen_svg__Punkte-2"
        />
      </g>
      <g id="stillestoppen_svg__dot-top-left" opacity={0}>
        <path
          className="stillestoppen_svg__st0"
          d="M220.6 808.1c17.2 0 31.2-14 31.2-31.2s-14-31.2-31.2-31.2-31.2 14-31.2 31.2 14 31.2 31.2 31.2"
          id="stillestoppen_svg__Punkte-3"
        />
      </g>
			<g id="hoeren">
				<path
					className="stillestoppen_svg__st0"
					d="M1370.4 1988.2l-1.3-.6-97.5 33.3v3.8c24.5 13.2 31.4 25.2 31.4 45.9V2204c0 40.3-6.3 50.3-38.4 54.7v5H1408v-5c-29.6-3.8-37.7-15.7-37.7-53.5v-217zm111.3 217c0 37.7-8.2 49.7-37.7 53.5v5h143.4v-5c-31.4-4.4-38.4-14.5-38.4-54.7v-135.2c0-48.4-20.1-80.5-72.3-80.5-32.7 0-69.2 22-88.7 47.2v1.9c13.2-5 28.9-8.8 44.7-8.8 36.5 0 49.1 18.2 49.1 52.2l-.1 124.4z"
					id="stillestoppen_svg__hoeren-n"
					opacity={0}
				/>
				<g id="stillestoppen_svg__hoeren-e" opacity={0}>
					<path
						className="stillestoppen_svg__st0"
						d="M1251.6 2085.1c0-49.1-40.3-95-103.2-96.9v5c27 3.2 36.5 40.3 38.4 79.9l-84.3 7.6v4.4h149.1z"
					/>
					<path
						className="stillestoppen_svg__st0"
						d="M1130.8 1989.5c-61 7.6-117 63.5-117 142.8 0 73 45.9 136.5 128.3 136.5 73 0 110.1-57.2 119.5-86.8l-3.2-2.5c-14.5 20.1-39.6 38.4-84.3 38.4-59.1 0-93.7-49.1-93.7-116.4 0-59.8 19.5-100 50.3-106.9l.1-5.1z"
					/>
				</g>
				<g id="stillestoppen_svg__hoeren-r" opacity={0}>
					<path
						className="stillestoppen_svg__st0"
						d="M886.9 1988.2l-1.3-.6-97.5 33.3v3.8c23.9 12.6 31.5 25.2 31.5 45.9V2204c0 40.3-6.3 50.3-38.4 54.7v5h150.3v-5c-29.6-3.1-44.7-13.8-44.7-54.1v-216.4zM969.3 2072.5c21.4 0 38.4-15.1 38.4-40.2 0-27-15.1-44-45.3-44-26.4 0-51.6 24.5-59.8 50.3v2.5c10.7-19.5 24.5-25.8 34-25.8 1.9 0 4.4.6 5 1.3-3.8 3.8-6.9 13.8-6.9 23.3 0 19.4 14.4 32.6 34.6 32.6"
					/>
				</g>
				<path
					className="stillestoppen_svg__st0"
					d="M684.7 1896.8c-17.7.1-32 14.4-32.1 32.1 0 17.6 14.5 32.7 32.1 32.7 18.2 0 32.1-15.1 32.1-32.7.1-17.6-14-31.9-31.6-32.1h-.5"
					id="stillestoppen_svg__hoeren-dot-right"
					opacity={0}
				/>
				<path
					className="stillestoppen_svg__st0"
					d="M570.3 1896.8c-17.7.1-32 14.4-32.1 32.1 0 17.6 14.5 32.7 32.1 32.7 18.2 0 32.1-15.1 32.1-32.7.1-17.6-14-31.9-31.6-32.1h-.5"
					id="stillestoppen_svg__hoeren-dot-left"
					opacity={0}
				/>
				<g id="stillestoppen_svg__hoeren-o" opacity={0}>
					<path
						className="stillestoppen_svg__st0"
						d="M702.3 2126c0 56.6-9.4 93.1-22.6 111.3-9.4 13.8-24.5 24.5-35.8 25.8v5c62.3-8.2 130.8-55.4 130.8-140.9 0-84.3-64.2-137.1-142.8-139v5c8.2.6 16.3 1.9 24.5 6.9 29.6 15.8 45.9 54.1 45.9 125.9M553.3 2130.4c0-56.6 9.4-93.7 22.6-112.6 9.4-13.2 22-22.6 35.8-24.5v-4.4c-61.6 6.3-131.5 55.3-131.5 141.5 0 83.6 64.8 136.5 143.4 138.4v-5c-8.2-.6-16.3-3.8-24.5-8.2-29.5-15.7-45.8-52.9-45.8-125.2"
					/>
				</g>
				<g id="stillestoppen_svg__hoeren-h" opacity={0}>
					<path
						className="stillestoppen_svg__st0"
						d="M260.2 1909.6c0-25.2 1.3-62.3 1.9-88.1l-1.2-.6-100 33.3v3.2c25.2 14.5 32.1 24.5 32.1 46.5v300c0 40.3-6.9 50.3-38.4 54.7v5H298v-5c-29.6-3.8-37.7-15.7-37.7-53.5l-.1-295.5z"
					/>
					<path
						className="stillestoppen_svg__st0"
						d="M371.6 2205.2c0 37.7-8.2 49.7-37.7 53.5v5h143.4v-5c-31.5-4.4-38.4-14.5-38.4-54.7v-134.6c0-47.8-20.8-81.1-72.3-81.1-32.7 0-69.2 22-88.7 47.2v1.9c14.2-5.6 29.4-8.6 44.7-8.8 36.5 0 49.1 18.9 49.1 53.5v123.1z"
					/>
				</g>
				<g id="stillestoppen_svg__and-symbol" opacity={0}>
					<g id="stillestoppen_svg__und">
						<defs>
							<path
								id="stillestoppen_svg__SVGID_1_"
								d="M1.9-27.2h1988v2394.8H1.9z"
							/>
						</defs>
						<clipPath id="stillestoppen_svg__SVGID_2_">
							<use xlinkHref="#stillestoppen_svg__SVGID_1_" overflow="visible" />
						</clipPath>
						<g clipPath="url(#stillestoppen_svg__SVGID_2_)">
							<path
								className="stillestoppen_svg__st0"
								d="M360.1 1275.2c-91.5 40.8-179.3 123.7-179.3 235 0 122.4 95.2 212.7 235 212.7 112.5 0 183-79.1 209-139.7l-6.2-6.2c-27.2 21-60.6 45.8-123.7 45.8-73 0-111.3-26-144.7-65.6-27.2-33.4-44.5-76.7-44.5-128.6 0-69.2 26-118.7 60.6-144.7l-6.2-8.7zm217.7-105.1c61.8-22.3 115-71.7 115-128.6 0-73-65.5-122.4-169.4-122.4-116.2 0-191.7 84.1-191.7 171.9 0 77.9 34.6 126.1 87.8 188 53.2 65.5 163.2 178.1 263.4 281.9 94 97.7 392 405.6 789 405.6 269.6 0 358.6-149.6 378.4-205.3l-7.4-6.2c-33.4 49.5-118.7 101.4-277 101.4-377.2 0-678.9-298-779.1-401.9-102.7-105.1-173.2-178.1-238.7-253.5-65.5-76.7-102.6-124.9-102.6-176.8 0-55.7 28.5-94 76.7-94 69.3 0 85.3 58.1 85.3 121.2 0 51.9-12.4 86.6-34.6 113.8l4.9 4.9zm236.1 228.7C890.6 1290 992 1180 1093.4 1165.1v-9.9H767v9.9c28.5 2.5 54.4 9.9 73 21 18.5 13.6 29.7 30.9 29.7 55.7 0 47-42 110.1-63.1 149.6l7.3 7.4z"
							/>
						</g>
					</g>
				</g>
      </g>
    </svg>
  );
});

export default SvgStillestoppen;
